// Styles
import styleGuideColors from 'commons/styleGuideColors';

export const transformToPercent = (data, field, newField) => {
  let totalMeasure = 0;
  data.forEach((element) => {
    totalMeasure += element[field];
  });
  return data.map((element) => {
    const newElement = {
      ...element
    };

    newElement[newField] = ((element[field] / totalMeasure) * 100)
      .toFixed(3)
      .slice(0, -1);

    return newElement;
  });
};

export const colorsProteinuria = [
  styleGuideColors.baxterBrandTeal,
  styleGuideColors.baxterBrandBaxterBlue,
  styleGuideColors.graphYellow,
  styleGuideColors.alertError,
  styleGuideColors.graphGreyStrokes
];
